import React from 'react'
// import { STYLES, COLORS } from 'x/config/styles'
import XIcon from './XIcon'

const SettingIcon = (props) => <XIcon name='settings' family='Ionicons' {...props} />

export default SettingIcon
